export default __webpack_public_path__ + "static/media/propic.2ab4a85e.jpeg";